// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"08ba9434","176":"4383beba","216":"fec12acc","360":"67527fc4","524":"5ccee876","810":"94ef5db3","856":"c2ca3f52","912":"3c8c04a4","952":"82742b43"}[chunkId] + ".chunk.js";
};